export default __webpack_public_path__ + "static/Gilead_worldaidsday_2-1bb78a1bee794c650a6b316433939543.jpg";